import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { DocumentViewModel } from '../viewModels/documents/documentViewModel';

@Injectable()
export class AttachmentsEventsEmitter {
  private readonly attachmentDeleted = new Subject<DocumentViewModel>();
  private readonly attachmentDownloaded = new Subject<DocumentViewModel>();
  private readonly attachmentDeletedSuccessfully = new Subject<DocumentViewModel>();

  attachmentDeleted$ = this.attachmentDeleted.asObservable();
  attachmentDownloaded$ = this.attachmentDownloaded.asObservable();
  attachmentDeletedSuccessfully$ = this.attachmentDeletedSuccessfully.asObservable();

  broadcastAttachmentDeleted(document: DocumentViewModel) {
    this.attachmentDeleted.next(document);
  }

  broadcastAttachmentDownloaded(document: DocumentViewModel) {
    this.attachmentDownloaded.next(document);
  }

  broadcastAttachmentDeletedSuccessfully(document: DocumentViewModel) {
    this.attachmentDeletedSuccessfully.next(document);
  }
}
